// v5.6.1 · Etiquetas de ejes de radar COMPLETAS: nombre limpio + texto en varias líneas (sin cortes ni abreviaturas).

/** «Bloque 1 · Aritmética (Básica 2°-8°)» → «Aritmética». Si queda vacío devuelve el original. */
export const cleanAxisLabel = (s) => {
  const raw = String(s ?? "");
  const out = raw
    .replace(/^\s*bloque\s*[\dIVXivx]+\s*[-–·:.]*\s*/i, "")
    .replace(/\s*\(.*?\)\s*$/, "")
    .trim();
  return out || raw;
};

const wrap = (text, max) => {
  const words = String(text).split(/\s+/).filter(Boolean);
  const lines = [];
  let cur = "";
  for (const w of words) {
    if (cur && (cur + " " + w).length > max) { lines.push(cur); cur = w; } else { cur = cur ? `${cur} ${w}` : w; }
  }
  if (cur) lines.push(cur);
  return lines.length ? lines : [""];
};

/** Tick personalizado de PolarAngleAxis: <PolarAngleAxis tick={(p) => <WrappedTick {...p} fontSize={10} />} /> */
export function WrappedTick({ x, y, textAnchor, payload, fontSize = 10, fill = "#41496a", maxChars = 12 }) {
  const lines = wrap(payload?.value, maxChars);
  const start = -((lines.length - 1) * 0.55);
  return (
    <text x={x} y={y} textAnchor={textAnchor} fontSize={fontSize} fill={fill} fontWeight={600}>
      {lines.map((l, i) => (
        <tspan key={i} x={x} dy={i === 0 ? `${start}em` : "1.1em"}>{l}</tspan>
      ))}
    </text>
  );
}
